import { integrationService } from './integrationService';
import api from '../utils/apiClient';

const DEFAULT_BLOG_AUTHOR = {
  bio: 'Senior real estate consultant and content strategist with over 15+ years of experience in the Indian property market. Specializes in residential and commercial real estate analysis, market trends, investment strategies, and property valuation across major cities including Delhi NCR, Mumbai, Bangalore, and Hyderabad. Expert in real estate content creation, market research, and providing strategic insights to homebuyers, investors, and industry professionals.',
  url: 'https://housing.com/news/tulip-infratech-launches-tulip-monsella-phase-2-in-gurgaon/',
  name: 'Dinesh Kataria',
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
  source: 'housing.com'
};

export const contentPublishService = {
  /**
   * Publish content to a specific integration
   * @param {Object} data - The content data to publish
   * @param {string} data.content - The HTML content to publish
   * @param {string} data.title - The title of the content
   * @param {string} data.integrationId - The ID of the integration to publish to
   * @param {string} [data.excerpt] - Optional excerpt for the content
   * @param {Array} [data.tags] - Optional tags for the content
   * @param {Array} [data.categories] - Optional categories for the content
   * @param {string} [data.featuredImage] - Optional featured image URL
   * @param {string} [data.slug] - Optional slug for the URL
   * @param {string} [data.metaTitle] - Optional meta title for SEO
   * @param {string} [data.metaDescription] - Optional meta description for SEO
   * @returns {Promise<Object>} - The result of the publish operation
   */
  async publishToIntegration(data) {
    try {
      if (!data.integrationId) {
        throw new Error('Integration ID is required');
      }

      // Get the integration details to determine type
      const integrations = await integrationService.listIntegrations(data.projectId);
      const integration = integrations.find(i => i.id === data.integrationId);

      if (!integration) {
        throw new Error('Integration not found');
      }

      // Based on integration type, call the appropriate publish method
      switch (integration.type) {
        case 'wordpress':
          return await integrationService.publishToWordPress(data);
        
        case 'webflow':
          return await integrationService.publishToWebflow(data);
        
        case 'notion':
          return await integrationService.publishToNotion(data);
        
        case 'shopify':
          return await integrationService.publishToShopify(data);
        
        case 'wix':
          return await integrationService.publishToWix(data);

        case 'api-webhook':
        case 'webhook':
          if (!data.keywordId) {
            throw new Error('API webhook publish requires keywordId');
          }
          {
            const response = await api.blogGeneration.publishBlog(data.keywordId, {
              integrationId: data.integrationId,
              publishStatus: data.status || 'published',
              city: data.city || 'Gurgaon',
              author: data.author || DEFAULT_BLOG_AUTHOR
            });
            return response.data;
          }
        
        // Add cases for other integration types as they are implemented
        
        default:
          throw new Error(`Publishing to ${integration.type} is not supported yet`);
      }
    } catch (error) {
      console.error('Error publishing content:', error);
      throw error;
    }
  },

  /**
   * Get available integrations for a project
   * @param {string} projectId - The ID of the project
   * @returns {Promise<Array>} - Array of available integrations
   */
  async getAvailableIntegrations(projectId) {
    try {
      const integrations = await integrationService.listIntegrations(projectId);
      // Filter to only return active integrations
      return integrations.filter(integration => integration.status === 'active');
    } catch (error) {
      console.error('Error getting available integrations:', error);
      throw error;
    }
  }
}; 